export * from '@storybook/addon-backgrounds/manager';
